import React, { Component } from 'react'
import { CallbackComponent } from 'redux-oidc'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import userManager from '../utils/userManager'

class Callback extends Component {
  render() {
    return (
      <CallbackComponent successCallback={(user) =>  {this.props.push('/')}} userManager={ userManager }>
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}

export default connect(null, { push })(Callback)